export default __webpack_public_path__ + "static/media/HeroBackground@md.e0325e38.jpg";